import Header from '../../../../googleAd/shared/sections/Header'
import { FirstView } from '../../../shared/sections/FirstView'
import EntryForm from '../../../shared/forms/EntryForm'
import { kansaiConfig } from './config.ts'
import { StepProvider } from '@/components/Context/StepContext'
import styles from './InstagramKansaiFormPage.module.css'
import { KansaiSpLandingPageProps } from './types.ts'
import { useAbTestGtm } from '@/components/utils/abTest'

const InstagramKansaiFormPage: React.FC<KansaiSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()

    return(
        <div className={styles.InstagramKansaiFormPageWrap}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header id='renewal_top' dataViewLabel={dataViewLabel('HD')} />
                <FirstView dataViewLabel={dataViewLabel('CT_FirstView')}/>
                <div className={styles.formWrap}>
                    <EntryForm
                        prefectures={prefectures}
                        config={kansaiConfig}
                    />
                </div>
            </StepProvider>
        </div>
    )
}

export default InstagramKansaiFormPage
